export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11598.9570434f.jpg";